import React from "react";
import Text from "@/components/ui/text";

interface ContractFieldProps {
  label: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
  width?: string;
}

const ContractField: React.FC<ContractFieldProps> = ({
  label,
  required = false,
  children,
  className = "",
  width = "w-full"
}) => {
  return (
    <div
      className={`flex flex-col gap-1 items-start justify-center rounded-md ${width} ${className}`}
    >
      <div className="flex gap-1 items-center min-h-6 w-full">
        <div className="flex flex-col gap-1 grow items-start justify-center">
          <div className="flex gap-2 items-center px-1 py-0 w-full">
            <div className="flex gap-1 h-5 items-start text-sm">
              <Text variant="bodySecondary">{label}</Text>
              {required && <Text variant="body">*</Text>}
            </div>
          </div>
        </div>
      </div>
      <div className="w-full">{children}</div>
    </div>
  );
};

export default ContractField;
